<template>
  <div class="upload">
    <el-upload
      :class="{ 'avatar-uploader': !isButton }"
      :multiple="false"
      :show-file-list="false"
      :data="formData"
      :action="uploadForm.action"
      :headers="uploadForm.headers"
      :before-upload="beforeUpload"
      :on-success="uploadSuccess"
      :on-error="uploadError"
      :on-progress="uploadProgress"
    >
      <div v-if="isButton">
        <el-button type="text" style="margin-right: 20px;">点击上传</el-button>
      </div>
      <div v-else>
        <div v-if="imageUrl">
          <img :src="getPreviewImageUrl(imageUrl)" class="avatar" />
        </div>
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </div>
    </el-upload>
    <el-button
      v-if="isButton"
      :disabled="!imageUrl"
      type="text"
      @click="handlerPreview"
      >点击预览</el-button
    >
    <div v-if="!imageUrl && !isButton" class="exampleImg">
      <img :src="exampleImg" />
      <span class="tipsMsg">上传示例</span>
    </div>
    <el-dialog :visible.sync="dialogVisible" title="预览" width="600px">
      <img
        style="width: 100%;height: 300px;"
        :src="getPreviewImageUrl(imageUrl)"
        alt=""
      />
    </el-dialog>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import { Loading } from "ccui";
export default {
  props: {
    isButton: {
      type: Boolean,
      default: false
    },
    imageUrl: {
      type: String,
      default: ""
    },
    exampleImg: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      dialogVisible: false,
      formData: {
        agentId: this.$router.history.current.query.a
      },
      uploadForm: {
        action: this.$addUrlPerFix(
          process.env.VUE_APP_BASE_URL +
            "/apis/sra/oss/users/signup/uploadFilePersNew"
        ),
        headers: {
          Authorization: Cookies.get("access_token") || ""
        }
      }
    };
  },
  computed: {
    getPreviewImageUrl() {
      return ossUrl => {
        return `${this.$addUrlPerFix(
          process.env.VUE_APP_BASE_URL
        )}/apis/sra/reg/users/signup/downloadByFileUrl?fileUrl=${ossUrl}&fileName=`;
      };
    }
  },
  methods: {
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 5;
      const allowedTypes = [
        "image/jpeg",
        "image/png",
        "image/bmp",
        "image/svg+xml"
      ];
      const isAllowedType = allowedTypes.includes(file.type);

      if (!isAllowedType) {
        this.$message.error("上传图片只能是 JPG, PNG, BMP 或 SVG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 5M!");
      }
      return isAllowedType && isLt2M;
    },
    uploadProgress(event, file, fileList) {
      //上传中,请稍等...
      this.uploadLoading = Loading.service({
        lock: true,
        text: "上传中,请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
        customClass: "ccui-custom-loading"
      });
    },
    async uploadSuccess(res, file, fileList) {
      this.uploadLoading.close();
      this.$message({
        message: "上传成功",
        type: "success",
        duration: 3000,
        showClose: true,
        ccuiCustom: true
      });
      const fileData = res.data[0];
      this.$emit("setUploadImageUrl", fileData);
    },
    uploadError(err, file, fileList) {
      this.$message({
        message: err.message,
        type: "error",
        duration: 3000,
        showClose: true,
        ccuiCustom: true
      });
      this.uploadLoading.close();
    },
    handlerPreview() {
      this.dialogVisible = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.upload {
  display: flex;
  .avatar-uploader {
    /deep/.el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      &:hover {
        border-color: #ff142f;
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 146px;
        height: 146px;
        line-height: 146px;
        text-align: center;
      }
      .avatar {
        width: 292px;
        height: 146px;
        display: block;
      }
    }
  }
  .exampleImg {
    display: flex;
    position: relative;
    width: 292px;
    height: 146px;
    margin-left: 20px;
    .tipsMsg {
      position: absolute;
      font-size: 26px;
      top: 59px;
      left: 78px;
    }
  }
}
</style>
